import { IPaginationResponse, IPaginatedListResponse } from '@/api/types';

/**
 * Extracts only pagination properties use for the paggination controls
 * @param response - The API response
 * @returns The pagination response
 */
export const extractPaginationResponse = (
  response: IPaginatedListResponse,
): IPaginationResponse => {
  if (!response) {
    return {
      page: 1,
      limit: 10,
      hasNextPage: false,
      hasPrevPage: false,
      nextPage: null,
      prevPage: null,
      totalDocs: 0,
      offset: 0,
      pagingCounter: 0,
      totalPages: 0,
    };
  }
  return {
    page: response.page,
    limit: response.limit,
    hasNextPage: response.hasNextPage,
    hasPrevPage: response.hasPrevPage,
    nextPage: response.nextPage,
    prevPage: response.prevPage,
    totalDocs: response.totalDocs,
    offset: response.offset,
    pagingCounter: response.pagingCounter,
    totalPages: response.totalPages,
  };
};

export function formatSortParam(
  sort: string | undefined,
  fallback: Record<string, 1 | -1>,
): string {
  try {
    const parsed = sort ? JSON.parse(sort) : {};
    if (
      parsed &&
      typeof parsed === 'object' &&
      Object.keys(parsed).length > 0
    ) {
      return JSON.stringify(parsed);
    }
  } catch {
    throw Error('Unable to parse sort parameter');
  }
  return JSON.stringify(fallback);
}
